<template>
  <div>
    <ListItemFilters
      icon="ui-icon-place"
      :title="t(getPlaceLabel({ place: doctorFiltersState.place }), options)"
      :subtitle="doctorFiltersState.place ? t(defaultPlaceName, options) : undefined"
      @click="openDialog"
    />

    <PlaceModal
      is-back
      :value="isDialogOpened"
      @input="handleClosePlaceModal"
    >
      <template #footer="{ selectedPlace }">
        <div class="pa-2 elevation-8">
          <v-btn
            block
            depressed
            color="primary"
            :disabled="!hasUnsavedPlace"
            @click="handlePlaceSelected(selectedPlace)"
          >
            {{ t('Применить', options) }}
          </v-btn>
        </div>
      </template>
    </PlaceModal>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import deepEqual from 'www/vue_components/common/TheFilters/doctors/functions/deepEqual'
import getPlaceLabel from 'www/vue_components/common/TheFilters/doctors/components/PlaceFilters/functions/getPlaceLabel'
import useCommonStore from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import PlaceModal from 'www/vue_components/common/TheFilters/doctors/components/PlaceFilters/components/PlaceModal.vue'
import ListItemFilters from 'www/vue_components/common/TheFilters/common/components/ListItemFilters/ListItemFilters.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const emit = defineEmits(['input', 'place:selected'])
const props = defineProps<{ value: Filters }>()

const { value: doctorFiltersState } = toRefs(props)

const commonStore = useCommonStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ListItemPlace')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const defaultPlaceName = commonStore.doctorList.hasMetro
  ? 'Метро, район'
  : 'Район'

const hasUnsavedPlace = computed(() => !deepEqual(doctorFiltersState.value.place, filtersStore.unsavedFilters.place))

const handleClosePlaceModal = () => {
  closeDialog()
  filtersStore.updateUnsavedFilters(doctorFiltersState.value)
}

const handlePlaceSelected = (place: Filters['place']) => {
  closeDialog()

  emit('input', {
    ...doctorFiltersState.value,
    place,
  })
}
</script>
